import { createContext, useCallback, useContext } from "react";
import useContentDoc from "../hooks/useContentDoc";
import messages from "./cabinetMessages.json";
const CabinetContext = createContext(null);
export function CabinetContentProvider({
  children,
  value
}) {
  const state = useContentDoc("siteContent", "userCabinet", {
    skip: value !== undefined
  });
  return <CabinetContext.Provider value={value === undefined ? state : {
    data: value,
    loading: false,
    error: null
  }}>{children}</CabinetContext.Provider>;
}
export function useCabinetContent() {
  return useContext(CabinetContext) || {
    data: null,
    loading: false,
    error: null
  };
}
export function useCabinetText(group) {
  const {
    data
  } = useCabinetContent();
  const texts = data?.messages?.[group];
  return useCallback(id => {
    const value = texts?.[id];
    return typeof value === "string" ? value : messages[group]?.[id] ?? "";
  }, [texts, group]);
}
export function withCabinetContent(Component) {
  function CabinetContentWrapper(props) {
    return <CabinetContentProvider><Component {...props} /></CabinetContentProvider>;
  }
  CabinetContentWrapper.displayName = `WithCabinetContent(${Component.displayName || Component.name || "Component"})`;
  return CabinetContentWrapper;
}
